/*
 * Copyright (c) 2025. World Wide Generation Ltd
 */

import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getSelection, $isRangeSelection, COMMAND_PRIORITY_LOW, FORMAT_TEXT_COMMAND, TextFormatType } from 'lexical';
import { $isVariableNode } from '../../nodes/VariableNode';

export const VariableFormatPlugin = (): null => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      FORMAT_TEXT_COMMAND,
      (format: TextFormatType) => {
        const selection = $getSelection();

        if (!$isRangeSelection(selection)) {
          return false;
        }

        const nodes = selection.getNodes();
        let hasVariableNode = false;

        nodes.forEach((node) => {
          if ($isVariableNode(node)) {
            hasVariableNode = true;
            node.toggleFormat(format);
          }
        });

        if (hasVariableNode) {
          return true;
        }

        return false;
      },
      COMMAND_PRIORITY_LOW,
    );
  }, [editor]);

  return null;
};
